import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = ["rows", "value"]
const _hoisted_5 = ["type", "rows", "placeholder", "maxlength"]
const _hoisted_6 = {
  key: 3,
  class: "text-end"
}
const _hoisted_7 = {
  class: "text-muted",
  style: {"font-size":"0.7rem"}
}
const _hoisted_8 = { class: "invalid-feedback" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TextAreaInput',
  props: {
    model: { default: () => ({}) },
    type: { default: "text" },
    label: { default: "" },
    placeholder: { default: "" },
    errorMsg: { default: "Por favor, preencha este campo corretamente" },
    value: { default: "" },
    readOnly: { type: Boolean, default: false },
    rows: { default: 6 },
    maxLength: { default: 1000 },
    required: { type: Boolean, default: false },
    showCharsLeft: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.readOnly)
      ? (_openBlock(), _createElementBlock("textarea", {
          key: 1,
          style: {"resize":"none"},
          rows: _ctx.rows,
          class: "form-control form-disabled",
          value: _ctx.value,
          disabled: ""
        }, null, 8, _hoisted_4))
      : _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 2,
          class: _normalizeClass(["form-control", { 'is-invalid': _ctx.model.$error }]),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.$model) = $event)),
          type: _ctx.type,
          rows: _ctx.rows,
          placeholder: _ctx.placeholder,
          maxlength: _ctx.maxLength
        }, null, 10, _hoisted_5)), [
          [
            _vModelText,
            _ctx.model.$model,
            void 0,
            { trim: true }
          ]
        ]),
    (_ctx.showCharsLeft && !_ctx.readOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("small", _hoisted_7, _toDisplayString(_ctx.maxLength - _ctx.model?.$model?.length || _ctx.maxLength) + " caracteres restantes", 1)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "content"),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("small", null, _toDisplayString(_ctx.errorMsg), 1)
    ])
  ]))
}
}

})